import { useState, useRef, useCallback, useEffect } from 'react';
import { getPillPositionFromContainer } from './BusinessTariffs.helpers';

export function useDurationPill(selectedDuration: string) {
  const [pillPosition, setPillPosition] = useState({ left: 0, width: 0 });
  const lastPillRef = useRef({ left: 0, width: 0 });
  const durationsContainerRef = useRef<HTMLDivElement | null>(null);

  const updatePillFromSelected = useCallback(() => {
    const container = durationsContainerRef.current;
    if (!container) return;
    const next = getPillPositionFromContainer(container, selectedDuration);
    if (!next) return;
    if (
      next.left !== lastPillRef.current.left ||
      next.width !== lastPillRef.current.width
    ) {
      lastPillRef.current = next;
      setPillPosition({ left: next.left, width: next.width });
    }
  }, [selectedDuration]);

  const measurePillForButton = useCallback(
    (el: HTMLButtonElement | null, days: string) => {
      if (
        el &&
        days === selectedDuration &&
        el.parentElement instanceof HTMLElement
      ) {
        const next = getPillPositionFromContainer(
          el.parentElement,
          selectedDuration
        );
        if (!next) return;
        if (
          next.left !== lastPillRef.current.left ||
          next.width !== lastPillRef.current.width
        ) {
          lastPillRef.current = next;
          setPillPosition({ left: next.left, width: next.width });
        }
      }
    },
    [selectedDuration]
  );

  useEffect(() => {
    const container = durationsContainerRef.current;
    if (!container) return;
    const onScrollOrResize = (): void => {
      updatePillFromSelected();
    };
    updatePillFromSelected();
    container.addEventListener('scroll', onScrollOrResize);
    const ro = new ResizeObserver(onScrollOrResize);
    ro.observe(container);
    return () => {
      container.removeEventListener('scroll', onScrollOrResize);
      ro.disconnect();
    };
  }, [updatePillFromSelected]);

  return { durationsContainerRef, pillPosition, measurePillForButton };
}
